import styled from 'styled-components/macro'
import { theme } from 'styled-tools'

const ProductPrice = styled.p`
  color: ${theme('productPrice')};
`
export default ProductPrice
